
import { Component, Vue } from "vue-property-decorator";
import Video from "@/lib/common/video";
import Dialog from "./components/dialog.vue";
import Toast from "./components/toast.vue";
import Result from "./components/result.vue";
import Progress from "./components/progress.vue";
import Intro from "./components/intro.vue";
import Sign from "./components/sign.vue";
import InputVerify from "./components/inputVerify.vue";
import UserMediaVerify from "./components/userMediaVerify.vue";
import UploadImage from "@/lib/common/uploadImage";
import request from "@/lib/request/request";
import "./assets/js/tracking-min.js";
import "./assets/js/face-min.js";
import FaceVerify, {
  AUTO_TYPE,
  CandidateInfo,
  ConfigData,
  ConnectCandidateData,
  LR_ERROR_AUTO_SUBMIT,
  RESULT_STATUS,
  ResultData
} from "@/lib/faceVerify/face-verify";
import { assign } from "lodash-es";
import ComponentConfig from "@/lib/component/component-config";
import router from "@/router";
import Agent from "@/lib/common/agent";

enum DialogType {
  ERROR = "error",
  FAIL = "fail",
  TIP = "tip"
}

enum FromPage {
  SIGN = "sign",
  VERIFY = "verify"
}

@Component({
  components: {
    Dialog,
    Progress,
    Intro,
    InputVerify,
    UserMediaVerify,
    Sign,
    Result,
    Toast
  }
})
/**
 * 1. 检查是否支持 getUserMedia：
 *  -> 如果支持，使用【video + canvas】
 *    -> 使用 tacking.js 检测人脸是否在框中，自动拍照，然后上传照片，调用接口 /v1/component/exec 核验
 *  -> 如果不支持，使用 input 框唤起相机
 *    -> 上传拍照的照片，调用接口 /v1/component/exec 核验
 * 2.
 */
export default class H5FaceVerify extends Vue {
  loading = false; // 上传中的loading
  commonErrMsg = "加载中...";

  percent = 100;
  isSupportUserMedia = true; // 是否可以使用 UserMedia

  connectCode = "";
  imgUrl: any = "";
  file: any = null;
  sessionId = ""; // 人脸核身组件标识
  hasPermission = true;

  created() {
    if (!this.isH5) {
      return;
    }
    this.init();
  }

  init() {
    this.checkSupport();
    this.getConnectCode();
    this.judgmentExamEnd();
    // this.getInfoByConnectCode();
  }

  checkSupport() {
    this.isSupportUserMedia = Video.checkSupport();
    console.log("this.isSupportUserMedia", this.isSupportUserMedia);
  }

  get isH5() {
    // 先不开启该功能
    return true;
    // return Agent.isMobile()
  }

  /** ================ 控制前后翻页 start =============== */

  currentStep = 0;
  stepPages = [
    {
      name: "pre", // 初始步骤先做一些检查（如 connectCode 等），如果不行则不会展示信息
      backColor: "back-white",
      isShow: true,
      isShowBackBtn: false
    },
    {
      name: "sign",
      backColor: "back-white",
      isShow: false,
      isShowBackBtn: false
    },
    {
      name: "intro",
      backColor: "back-black",
      isShow: false,
      isShowBackBtn: true
    },
    {
      name: "verify",
      backColor: "back-white",
      isShow: false,
      isShowBackBtn: true
    }
    // {
    //   name: "result",
    //   backColor: "",
    //   isShow: false,
    //   isShowBackBtn: false
    // }
  ];

  get isHideBack() {
    const step = this.currentStep;
    return this.stepPages[step].isShowBackBtn;
  }

  get defaultBackColor() {
    const step = this.currentStep;
    if (step === 3 && !this.hasPermission) {
      return "back-black";
    }
    return this.stepPages[step].backColor;
  }

  // 设置返回按钮的颜色
  backColor = "back-white";
  setBackColor(color?: string) {
    // color: black white
    if (color) {
      this.backColor = color === "black" ? "back-black" : "back-white";
    } else {
      this.backColor = this.defaultBackColor as string;
    }
  }

  nextStep() {
    if (this.currentStep >= this.stepPages.length - 1) {
      this.currentStep = this.stepPages.length - 1;
      return;
    }
    this.changeStep(1);
    this.setBackColor();
  }

  preStep() {
    if (this.currentStep <= 0) {
      this.currentStep = 0;
      return;
    }
    this.changeStep(-1);
  }

  changeStep(step: number) {
    console.log("changeStep");
    this.currentStep = this.currentStep + step;
    this.handleBackToSignPage();
    this.stepPages.forEach((item, index) => {
      if (index === this.currentStep) {
        item.isShow = true;
      } else {
        item.isShow = false;
      }
    });
  }

  setFirstStep() {
    this.currentStep = 0;
    this.changeStep(0);
  }

  setCertainStep(step: number) {
    this.currentStep = step;
    this.changeStep(0);
  }

  setLastStep() {
    this.currentStep = this.stepPages.length - 1;
    this.changeStep(0);
  }
  /** ================ 控制前后翻页 end =============== */

  getConnectCode() {
    this.connectCode = (this.$route.query.c as string).replace(
      /[^a-zA-Z0-9]/g,
      ""
    );
  }

  logoUrl = "";
  mainColor = "#525FFF";
  examId = "";
  examInfo = {
    examId: "",
    params: []
  };
  // 需要反显到页面的信息
  connectCandidate = new ConnectCandidateData();
  async getInfoByConnectCode() {
    try {
      if (this.connectCode.startsWith("4")) {
        const result = await request.post(
          "/aiExam/old/connect",
          {
            connectCode: this.connectCode,
            needCheck: 1 // 会校验是否禁止公开邀请
          },
          false
        );
        console.log(
          "🚀 ~ H5FaceVerify ~ getInfoByConnectCode ~ result:",
          result
        );
        const data = result.data.data;
        this.examInfo.examId = data.examId;
        this.examInfo.params = data.params;
        this.mainColor = data.companySpecialConfig.styleConfig.mainColor;
      } else if (this.connectCode.startsWith("5")) {
        const result = await request.post(
          "/aiExam/old/connectCandidate",
          {
            connectCode: this.connectCode,
            infoOnly: 1
          },
          false
        );
        console.log(
          "🚀 ~ H5FaceVerify ~ getInfoByConnectCode ~ result:",
          result
        );
        const data = result.data.data;
        this.examInfo.examId = data.examInfo.examId;
        this.examInfo.params = data.examInfo.params;
        this.mainColor =
          data.examInfo.companySpecialConfig.styleConfig.mainColor;
        this.connectCandidate.idNumber = data.candidateInfo.idNumber;
        this.connectCandidate.showName = data.candidateInfo.showName;
        this.connectCandidate.phone = data.candidateInfo.phone;
      } else {
        this.mainColor = "#525FFF";
      }
      // 去登记页面
      this.nextStep();
    } catch (error) {
      console.error("getInfoByConnectCode catch error:", error);
      const errMsg = error?.data?.message || this.commonErrMsg + ".";
      if (error?.data?.code === 200003) {
        this.openMiniProgram(true);
      } else {
        (this.$refs.toast as InstanceType<typeof Toast>)?.showToast(errMsg);
      }
      this.mainColor = "#525FFF";
    }
  }

  /** ==================== 核验相关 start =========================== */

  resultData = new ResultData();
  configData = new ConfigData();
  // 剩余核验次数 = 组件配置中的失败重试次数 - 累计提交次数 + 1
  get remainVerifyCount() {
    return this.configData.lrRetryNumberLimit - this.resultData.number + 1;
  }

  get verifyErrorMessage() {
    return this.resultData?.msg || this.commonErrMsg;
  }
  // 是否不能核验
  get notVerify() {
    return this.remainVerifyCount <= 0;
  }

  // 点击按钮【开始核验】
  startVerify() {
    try {
      if (this.isSupportUserMedia) {
        (this.$refs.userMediaVerify as InstanceType<
          typeof UserMediaVerify
        >)?.openUserMedia();
      } else {
        // 拍照
        (this.$refs.inputVerify as InstanceType<
          typeof InputVerify
        >)?.openCamera();
      }
    } catch (e) {
      console.error("startVerify catch error:", e);
    }
  }

  // 关闭 userMedia
  closeUserMedia() {
    try {
      if (this.isSupportUserMedia) {
        (this.$refs.userMediaVerify as InstanceType<
          typeof UserMediaVerify
        >)?.close();
      }
    } catch (e) {
      console.error("🚀 ~ H5FaceVerify ~ closeUserMedia ~ e:", e);
    }
  }

  // 上传图片 & 核验
  async uploadAndVerify(file: File) {
    this.file = file;
    this.loading = true;
    try {
      this.imgUrl = await UploadImage.uploadImg(this.file);
      console.log(this.imgUrl);
      const resp = await this.apiComponentExec();
      const responseData = resp?.responseData || {};
      this.resultData = assign(this.resultData, responseData);
      this.faceVerifyResult(FromPage.VERIFY);
    } catch (e) {
      console.error("uploadAndVerify catch error:", e);
    } finally {
      this.loading = false;
    }
  }

  // 核验失败弹框-取消
  onErrorDialogCancel() {
    this.handleInputCameraStep();
    if (this.noPreStep) {
      return;
    }
    this.preStep();
  }

  // 核验失败弹框-已超过核验次数限制按钮
  onFailDialogOk() {
    this.handleInputCameraStep();
    if (this.noPreStep) {
      return;
    }
    this.preStep();
  }

  // 如果不支持 user media，使用 input 唤起 camera 的时候，
  // 不需要再跳转到下一页了，停留在 intro 所在的页面即可，因为如果在下一页用户取消了拍照，那么用户就会停留在空白页面了
  handleInputCameraStep() {
    if (!this.isSupportUserMedia) {
      this.noPreStep = true;
      return true;
    } else {
      return false;
    }
  }

  // 核验成功处理
  onFaceVerifySuccess() {
    this.openMiniProgram();
  }

  /**
   * 处理两种情况：
   * 1. 从登记页面进入时：检查一下核验的结果
   * 2. 开始核验后，从接口处获得的人脸核验结果
   * @param from - 来源： sign 登记信息页面过来的，verify 人脸核验过来的
   */
  faceVerifyResult(from = FromPage.SIGN) {
    try {
      // 如果 1，则认为人脸核验成功，可以跳转小程序
      if (this.resultData.resultStatus === RESULT_STATUS.SUCCESS) {
        this.closeUserMedia();
        this.openMiniProgram();
        return;
      }
      // 如果核验失败 或者 如果核验错误且没有重试次数
      if (
        this.resultData.resultStatus === RESULT_STATUS.FAIL ||
        this.notVerify
      ) {
        // 自动交卷
        if (this.configData.lrErrorAutoSubmit === LR_ERROR_AUTO_SUBMIT.YES) {
          if (this.handleInputCameraStep() && from === FromPage.VERIFY) {
            console.log("不继续");
          } else {
            this.nextStep();
          }
          this.openDialog(DialogType.FAIL);
          if (from === FromPage.SIGN) {
            this.noPreStep = true;
          } else {
            this.noPreStep = false;
            this.apiSubmit();
          }
        } else {
          this.openMiniProgram();
        }
        this.closeUserMedia();
        return;
      }

      // 如果核验错误且有重试次数
      if (from === FromPage.SIGN) {
        // 从登记页面过来时判断是否需要再人脸核验
        this.nextStep();
      } else {
        // 人脸核验的结果展示
        this.openDialog(DialogType.ERROR);
      }
    } catch (e) {
      console.error("🚀 ~ H5FaceVerify ~ faceVerifyResult ~ e:", e);
    }
  }

  /** ==================== 核验相关  end =========================== */

  getFaceVerifyComponent(componentList: any) {
    const com = componentList.filter(
      (v: any) => v.type == "livenessRecognition"
    );
    if (com.length) {
      return com[0];
    } else {
      return null;
    }
  }
  candidateInfo = new CandidateInfo();
  async getComponentInfo(candidateInfo: CandidateInfo) {
    try {
      this.candidateInfo = candidateInfo;
      const componentRes = await this.getComponentConfigByCandidate(
        candidateInfo.candidateConnectCode
      );
      const comConfig = this.getFaceVerifyComponent(componentRes.componentList);
      if (comConfig) {
        this.sessionId = comConfig?.sessionId || "";
      } else {
        const message = "该面试没有配置该功能";
        try {
          (this.$refs.toast as InstanceType<typeof Toast>)?.showToast(message);
        } catch (e) {
          console.log("🚀 ~ H5FaceVerify ~ getComponentInfo ~ e:", e);
        }
        return;
      }

      const configRes = await this.apiComponentConfig(this.sessionId);
      console.log(
        "🚀 ~ H5FaceVerify ~ getComponentInfo ~ configRes:",
        configRes
      );
      const configData = configRes?.configData || {};
      this.configData = configData;
      const resultRes = await this.apiComponentResult(this.sessionId);
      console.log(
        "🚀 ~ H5FaceVerify ~ getComponentInfo ~ resultRes:",
        resultRes
      );
      const resultData = resultRes?.resultData || {};
      this.resultData = resultData;
      this.faceVerifyResult();
    } catch (err) {
      console.error("getComponentInfo catch error:", err);
      const errMsg = err?.data?.message || this.commonErrMsg + "..";
      (this.$refs.toast as InstanceType<typeof Toast>)?.showToast(errMsg);
    }
  }

  // 在登记之后，开题前获取人脸核身的配置，如 sessionId 等
  getComponentConfigByCandidate(candidateConnectCode: string) {
    return FaceVerify.getComponentInfoByCandidate(candidateConnectCode);
  }

  // 查询组件配置
  apiComponentConfig(sessionId: string) {
    return ComponentConfig.config(sessionId);
  }
  // 查询组件结果
  apiComponentResult(sessionId: string) {
    return ComponentConfig.result(sessionId);
  }
  // 组件保存 并 得到结果
  apiComponentExec() {
    const req = {
      sessionId: this.sessionId,
      saveData: {
        name: this.candidateInfo.name,
        idNumber: this.candidateInfo.idNumber,
        imgUrl: this.imgUrl
      }
    };
    return ComponentConfig.exec(req);
  }

  // 自动交卷
  apiSubmit() {
    const autoType =
      this.resultData.resultStatus === RESULT_STATUS.FAIL
        ? AUTO_TYPE.VERIFY_ERROR
        : AUTO_TYPE.VERIFY_REACH_MAX_COUNT;
    const req = {
      connectCode: this.candidateInfo.candidateConnectCode,
      isAutoSubmit: 1,
      autoType
    };
    return FaceVerify.submit(req);
  }

  /** ==================== 弹框相关 start =========================== */

  dialogVisible = false; // 是否展示提示框
  dialogType = DialogType.TIP; // 提示框展示的信息类型

  get dialogInfo() {
    return this.getDialogInfo(this.dialogType);
  }

  // 获取弹窗的配置信息
  getDialogInfo(type: string) {
    const content = {
      [DialogType.ERROR]: {
        title: "核验失败",
        content: `${this.verifyErrorMessage}<br />（剩余核验次数${this.remainVerifyCount}次）`,
        okText: "重新认证",
        cancelText: "取消",
        cancelBtnShow: true,
        ok: () => {
          console.log("error ok");
          this.closeDialog();
          // 需要跳转到登记信息页面重新开始
          if (this.resultData.errorType === 2) {
            this.setCertainStep(1);
          } else {
            this.$nextTick(() => {
              this.startVerify();
            });
          }
        },
        cancel: () => {
          console.log("error cancel");
          this.closeDialog();
          this.handleInputCameraStep();
          this.onErrorDialogCancel();
        }
      },
      [DialogType.FAIL]: {
        title: "核验失败",
        content: "人脸信息与身份信息不符，如有问题请与HR联系",
        okText: "我知道了",
        cancelBtnShow: false,
        ok: () => {
          console.log("fail ok");
          this.closeDialog();
          this.handleInputCameraStep();
          this.onFailDialogOk();
        },
        cancel: () => {
          console.log("fail cancel");
        }
      },
      [DialogType.TIP]: {
        title: "请按照下面拍摄要求进行拍摄",
        content:
          "请把脸正对屏幕拍摄<br />请不要遮挡脸部<br />请在光线充足的环境下拍摄",
        okText: "准备好了",
        cancelBtnShow: false,
        ok: () => {
          console.log("tip ok");
          this.closeDialog();
          // 展示人脸核验
          if (!this.handleInputCameraStep()) {
            this.nextStep();
            this.hasPermission = true;
          }
          this.$nextTick(() => {
            this.startVerify();
          });
        },
        cancel: () => {
          console.log("tip cancel");
        }
      }
    };
    return content[type];
  }

  noPreStep = false;
  openIntroDialog() {
    try {
      if (this.notVerify) {
        this.closeUserMedia();
        this.openDialog(DialogType.FAIL);
        this.noPreStep = true;
      } else {
        this.openDialog(DialogType.TIP);
      }
    } catch (e) {
      console.error("🚀 ~ H5FaceVerify ~ openIntroDialog ~ e:", e);
    }
  }

  openDialog(type: DialogType = DialogType.TIP) {
    this.dialogType = type;
    this.dialogVisible = true;
  }

  closeDialog() {
    this.dialogVisible = false;
  }
  /** ==================== 弹框相关  end =========================== */

  baseHost = "http://aic.hina.com";
  get redirectUrl() {
    const env = process.env.NODE_ENV === "production" ? "" : 1;
    return `${this.baseHost}/a?a=0&c=${this.candidateInfo.candidateConnectCode}&env=${env}`;
  }

  // 禁止公开邀请（old/connect 接口增加了 needCheck 做了校验，如果禁止会返回 200003 错误码）
  //     因为小程序中如果是 4 开头的码会做禁止公开邀请的逻辑（也是基于 200003 做判断）
  //     为了让开了H5人脸核身的面试和未开该功能的表现形式一致（即都在小程序中做判断），因此直接用 4 开头的码跳转即可
  get disableOpenPublicQrCodeRedirectUrl() {
    const env = process.env.NODE_ENV === "production" ? "" : 1;
    return `${this.baseHost}/a?a=0&c=${this.connectCode}&env=${env}`;
  }

  // 跳转小程序
  openMiniProgram(isDisabledPublicQrCode = false) {
    if (isDisabledPublicQrCode) {
      window.location.href = this.disableOpenPublicQrCodeRedirectUrl;
    } else {
      window.location.href = this.redirectUrl;
    }
  }

  isEnd = false;
  showResultPage = false;
  joinStatusInfo = {} as any;
  // 判断面试是否结束
  async judgmentExamEnd() {
    try {
      const result = await request.post(
        "/aiExam/old/joinStatus",
        {
          connectCode: this.connectCode
        },
        false
      );
      console.log("judgementExamEnd", result);
      if (result.data.code === 0) {
        this.joinStatusInfo = result.data?.data || {};
        //面试已结束 或 面试登记已截止  则展示页面
        this.isEnd =
          this.joinStatusInfo.joinStatus == 1 ||
          this.joinStatusInfo.joinStatus === 2 ||
          this.joinStatusInfo.isExpireRegisterTimeLimit === 1;
        if (this.isEnd) {
          this.setFirstStep();
          // 展示结果页面
          this.showResultPage = true;
        } else {
          this.getInfoByConnectCode();
        }
      } else {
        const errMsg = this.commonErrMsg;
        (this.$refs.toast as InstanceType<typeof Toast>)?.showToast(errMsg);
      }
    } catch (error) {
      console.error("judgmentExamEnd catch error:", error);
      const errMsg = this.commonErrMsg;
      (this.$refs.toast as InstanceType<typeof Toast>)?.showToast(errMsg);
    }
  }

  // 在回到 sign 页面场景下，需要清空短信验证码：
  // 1. intro 页面返回到 sign 页面；
  // 2. 如果是因为姓名和身份证等不一致的时候，点击弹框的【重新核验】按钮
  handleBackToSignPage() {
    try {
      (this.$refs.signRef as InstanceType<typeof Sign>)?.afterSign();
    } catch (e) {
      console.error("handleBackToSignPage catch error", e);
    }
  }
}
